
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img
                src="https://public.readdy.ai/ai/img_res/bb5b4f5c-6921-444f-be70-983bff8d900a.png"
                alt="청주 아이폰수리 마켓"
                className="h-12 w-auto object-contain"
              />
              <div>
                <h1 className={`text-2xl font-bold transition-colors ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}>청주 아이폰수리 마켓</h1>
                <p className={`text-xs transition-colors ${
                  isScrolled ? 'text-gray-600' : 'text-gray-200'
                }`}>15년 경력의 신뢰</p>
              </div>
            </div>

            {/* 데스크탑 메뉴 */}
            <div className="hidden md:flex items-center space-x-8">
              {['home','services','about','testimonials','faq','contact'].map((id, i) => {
                const labels = ['홈','서비스','소개','후기','FAQ','문의'];
                return (
                  <button
                    key={id}
                    onClick={() => scrollToSection(id)}
                    className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                      isScrolled ? 'text-gray-700 hover:text-[#007AFF]' : 'text-white hover:text-[#007AFF]'
                    }`}
                  >
                    {labels[i]}
                  </button>
                );
              })}
              <a
                href="https://open.kakao.com/o/sMCniBii"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#FEE500] text-[#3A1D1D] text-sm font-bold px-4 py-2 rounded-full hover:bg-[#f5dc00] transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-kakao-talk-fill text-base"></i>
                </span>
                카카오톡 문의
              </a>
            </div>

            {/* 모바일 우측: 카카오 + 햄버거 */}
            <div className="flex md:hidden items-center gap-3">
              <a
                href="https://open.kakao.com/o/sMCniBii"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 bg-[#FEE500] text-[#3A1D1D] text-xs font-bold px-3 py-2 rounded-full hover:bg-[#f5dc00] transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-kakao-talk-fill text-sm"></i>
                </span>
                카카오톡
              </a>
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className={`w-8 h-8 flex items-center justify-center cursor-pointer transition-colors ${
                  isScrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* 모바일 드로어 메뉴 */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg border-t border-gray-100">
            <div className="px-6 py-4 space-y-1">
              {['home','services','about','testimonials','faq','contact'].map((id, i) => {
                const labels = ['홈','서비스','소개','후기','FAQ','문의'];
                return (
                  <button
                    key={id}
                    onClick={() => scrollToSection(id)}
                    className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#007AFF] py-3 border-b border-gray-50 cursor-pointer whitespace-nowrap"
                  >
                    {labels[i]}
                  </button>
                );
              })}
              <div className="pt-3">
                <a
                  href="https://open.kakao.com/o/sMCniBii"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-[#FEE500] text-[#3A1D1D] text-sm font-bold px-4 py-3 rounded-full hover:bg-[#f5dc00] transition-colors cursor-pointer whitespace-nowrap w-full"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-kakao-talk-fill text-base"></i>
                  </span>
                  카카오톡으로 문의하기
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* 모바일 하단 고정 카카오톡 버튼 */}
      <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden">
        <a
          href="https://open.kakao.com/o/sMCniBii"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-[#FEE500] text-[#3A1D1D] font-bold py-4 text-base cursor-pointer whitespace-nowrap w-full shadow-lg"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-kakao-talk-fill text-xl"></i>
          </span>
          카카오톡으로 바로 상담하기
        </a>
      </div>
    </>
  );
}
